import { create } from "zustand";
import { persist } from "zustand/middleware";

import { addItem } from "@/cart/addItem";
import { addDiscountCode } from "@/cart/addDiscountCode";
import { STORAGE_KEY } from "@/cart/consts";
import { initializeCart } from "@/cart/initializeCart";
import { removeItem } from "@/cart/removeItem";
import { CartState } from "@/cart/types";
import { updateItem } from "@/cart/updateItem";

const useCart = create<CartState>()(
  persist(
    (set, get) => ({
      cartId: undefined,
      cart: undefined,

      initializeCart: initializeCart({ set, get }),
      addItem: addItem({ set, get }),
      removeItem: removeItem({ set, get }),
      updateItem: updateItem({ set, get }),
      addDiscountCode: addDiscountCode({ set, get }),
    }),
    {
      name: STORAGE_KEY,
      partialize: s => ({ cartId: s.cartId }),
      onRehydrateStorage: () => state => {
        state?.initializeCart();
      },
    }
  )
);

export default useCart;
